module.exports = __webpack_public_path__ + "img/close-eyes-icon.17602990.png";